import { useMutation } from '@tanstack/react-query';

import { paymentProviderTypes } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';
import { Departments } from '@/types';

export const removePaymentProvider: paymentProviderTypes.RemovePaymentProviderData = ({ _id }) => {
  return axios.delete(`/payment-providers/${_id}`);
};

type QueryFnType = typeof removePaymentProvider;

type UseRemovePaymentProviderOptions = {
  department: Departments;
  config?: MutationConfig<(params: Parameters<QueryFnType>[0]) => ReturnType<QueryFnType>>;
};

export function useRemovePaymentProvider({
  config = {},
  department,
}: UseRemovePaymentProviderOptions) {
  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries(['payment-providers', department]);
    },
    ...config,
    mutationFn: removePaymentProvider,
  });
}
